import { inject, Injectable } from '@angular/core';
import { catchError, finalize, forkJoin, Observable } from 'rxjs';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { map, tap } from 'rxjs/operators';
import { IHowToVideo } from '../../interfaces/howTo/IHowToVideo';
import { HowtoService } from '../../services/howto.service';
import { S3ExportType } from '../../enums/S3ExportType.enum';
import { videos } from '../../configs/howTo.config';
import { LoadVideos } from './howTo.actions';

export interface HowToStateModel {
  videos: IHowToVideo[];
  isLoading: boolean;
}

@State<HowToStateModel>({
  name: 'howToState',
  defaults: {
    videos: [],
    isLoading: false,
  },
})
@Injectable()
export class HowToState {
  private howToService = inject(HowtoService);

  @Selector()
  static videos(state: HowToStateModel): IHowToVideo[] {
    return state.videos;
  }

  @Selector()
  static isLoading(state: HowToStateModel): boolean {
    return state.isLoading;
  }

  @Action(LoadVideos)
  loadVideos(ctx: StateContext<HowToStateModel>): Observable<IHowToVideo[]> {
    this.setIsLoading(ctx, true);

    return forkJoin(
      videos.map(video =>
        this.howToService.getObject(video.fileName, S3ExportType.VIDEO).pipe(
          map(blob => {
            return {
              ...video,
              url: URL.createObjectURL(blob),
            };
          }),
          catchError(error => {
            throw new Error(error);
          }),
        ),
      ),
    ).pipe(
      tap(result => {
        ctx.patchState({
          videos: result,
        });
      }),
      finalize(() => this.setIsLoading(ctx, false)),
    );
  }

  private setIsLoading(ctx: StateContext<HowToStateModel>, isLoading: boolean): void {
    ctx.patchState({ isLoading });
  }
}
